import Banner, { BannerType } from "components/common/Banner";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { loadSystemMessages, setSystemMessages } from "store/masterData/masterDataActions";
import { SystemMessageTypes } from "store/masterData/masterDataTypes";
import useSelector from "store/useSelector";
import "./SystemMessages.scoped.scss";

const SystemMessages: React.FC = () => {
    const {
        masterData: {
            systemMessages,
        },
    } = useSelector(store => store);
    const dispatch = useDispatch();

    const fetchData = () => {
        dispatch(loadSystemMessages());
    };

    useEffect(() => {
        fetchData();

        const intervalId = setInterval(() => {
            fetchData();
        }, 5 * 60 * 1000);

        return () => {
            clearInterval(intervalId);
        };
    }, []);

    const onHandleCloseBanner = (id: number) => {
        let newMsgs = systemMessages.filter(msg => msg.id !== id);
        dispatch(setSystemMessages(newMsgs));
    }

    return (
        (systemMessages &&
            systemMessages.map(x => (
                <>
                    <Banner
                        key={x.id}
                        type={getBannerType(x.messageType)}
                        closeButton={true}
                        onCloseBanner={() => onHandleCloseBanner(x.id)}>
                        {x.message}
                    </Banner>
                </>
            ))
        )
    );
};

const getBannerType = (type: SystemMessageTypes): BannerType => {
    switch (type) {
        case SystemMessageTypes.Caution: return BannerType.Warn;
        case SystemMessageTypes.Warning: return BannerType.Error;
        default: return BannerType.Info;
    }
}

export default SystemMessages;